<template>
  <div
    class="social-icon-section"
    :class="{
      'social-icon-section--stacked': localStacked,
      'social-icon-section-minimal': minimal
    }"
  >
    <h5 class="social-icon-header">{{ socialMediaHeaderText }}</h5>
    <div class="social-icons">
      <template v-for="item in socialMediaList">
        <a
          v-if="item.socialIconLink"
          :key="item.socialIconLink"
          :class="item.socialIconType"
          class="social-icon-link"
          :href="item.socialIconLink"
          target="_blank"
        >
          <img
            class="social-icon-image"
            :src="getFullyQualifiedUrl(item.socialIconUrl)"
            :alt="item.socialIconType"
          />
        </a>
      </template>
    </div>
  </div>
</template>

<script>
import { getFullUrl } from "@nuskin/ns-common-lib";

import facebook from "../assets/facebook.svg";
import instagram from "../assets/instagram.svg";
import twitter from "../assets/twitter.svg";
import pinterest from "../assets/pinterest.svg";

export default {
  name: "NsSocialIcons",
  props: {
    /**
     * List of icons ([{socialIconLink, socialIconType, socialIconUrl}])
     */
    socialMediaList: {
      type: Array,
      default() {
        return [
          {
            socialIconType: "facebook",
            socialIconUrl: facebook,
            socialIconLink: "https://facebook.com/nuskin"
          },
          {
            socialIconType: "instagram",
            socialIconUrl: instagram,
            socialIconLink: "https://instagram.com/nuskin"
          },
          {
            socialIconType: "twitter",
            socialIconUrl: twitter,
            socialIconLink: "https://twitter.com/nuskin"
          },
          {
            socialIconType: "pinterest",
            socialIconUrl: pinterest,
            socialIconLink: "https://pinterest.com/nuskin"
          }
        ];
      },
      validator: value =>
        Array.isArray(value) &&
        value.every(item =>
          ["socialIconLink", "socialIconUrl"].every(
            prop => item[prop] && typeof item[prop] === "string"
          )
        )
    },
    /**
     * A title to display next to the icons
     */
    socialMediaHeaderText: {
      type: String,
      default: "CONNECT WITH NU SKIN"
    },
    /**
     * enable Minimal footer mode
     */
    minimal: {
      type: Boolean,
      default: false
    },
    /**
     * Stacks the title on top of the icons
     */
    stacked: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    siteUrl() {
      return this.$NsAppService.siteUrl || "";
    },
    localStacked() {
      if (this.stacked === null) {
        return this.$mq !== "tablet";
      } else {
        return this.stacked;
      }
    }
  },
  methods: {
    getFullyQualifiedUrl(url) {
      return getFullUrl(this.siteUrl, url);
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";
@use "~@nuskin/ns-core-styles/src/scss/colors";

.social-icon-section {
  display: flex;
  align-items: center;

  &.social-icon-section--stacked {
    display: block;

    .social-icon-header {
      margin-bottom: 10px;
    }
  }
}

.social-icon-header {
  color: map.get(colors.$themeColors, color-background-1);
  margin-right: 30px;
  font-size: 13px;
  font-family: map.get(typographyVariables.$typography, font-family-primary);
  font-weight: map.get(typographyVariables.$typography, font-weight-semibold);
}

.social-icon-link {
  padding: 0 5px;
  text-decoration: none !important;
  color: map.get(colors.$themeColors, color-white) !important;
}

.social-icon-image {
  display: block;
}

.social-icons {
  margin: 0 -5px;
  display: flex;
  align-items: center;
}

.social-icon-section-minimal {
  margin-left: 15px;
  .social-icon-header {
    color: black;
  }
}
@media (max-width: 768px) {
  .social-icon-section-minimal.social-icon-section.social-icon-section--stacked {
    .social-icon-header {
      display: none;
    }
  }
}
</style>
